import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import ModalSidebar from '../../../../components/ModalSidebar';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';
import { useMyAbsenceDaysQuery } from '../../../../__generated__/graphql';
import ServerError from '../../../../../../components/ServerError';
import Loading from '../Loading';
import { mapAbsenceDays } from './mapping';
import { FlairDateFormat } from '../../../../../../atomic/atoms/FlairFormattedDate/types';
import FlairFormattedDate from '../../../../../../atomic/atoms/FlairFormattedDate';

type Props = {
  absenceId: string;
  show: boolean;
  onClose: () => void;
};

const MultiDayAbsenceDetails: React.FC<React.PropsWithChildren<Props>> = ({
  absenceId,
  show,
  onClose,
}) => {
  const t = useNamespacedTranslation('absences.absenceDays');
  const { data, loading, error } = useMyAbsenceDaysQuery({
    variables: { absenceId },
  });

  if (error) {
    return <ServerError />;
  }

  const absenceDays = mapAbsenceDays(data?.absence?.absenceDays ?? []);

  return (
    <ModalSidebar
      show={show}
      onClose={onClose}
      header={t('title')}
      content={
        <div className="p-3">
          {loading ? (
            <Loading />
          ) : (
            <div>
              {absenceDays.map((day) => (
                <Card className="shadow-sm">
                  <Card.Body>
                    <Row>
                      <Col>
                        <h5 className="mb-2">
                          <FlairFormattedDate
                            day={day.day}
                            format={FlairDateFormat.WeekdayShortMonthDayYear}
                          />
                        </h5>
                        <div className="text-muted">
                          {day.startTime} - {day.endTime}
                        </div>
                        <div className="small text-muted mt-1">
                          {t('hoursDeducted')}: {day.hours}
                        </div>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              ))}
            </div>
          )}
        </div>
      }
    />
  );
};

export default MultiDayAbsenceDetails;
